import script from "./CustomAdmSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomAdmSidebar.vue?vue&type=script&setup=true&lang=js"

import "./CustomAdmSidebar.vue?vue&type=style&index=0&id=7a6b5701&lang=scss"

const __exports__ = script;

export default __exports__